export type SettingsTabId =
  | "providers"
  | "branding"
  | "channels"
  | "connectors"
  | "agent-teams"
  | "api-keys"
  | "archived"
  | "security";

/**
 * Each tab is a real route rather than local state, so a tab is linkable, keeps
 * its place through Back, and opens in a new tab from a modified click.
 * `authority` is the same gate the route itself enforces: a viewer only sees
 * tabs they may open, never a disabled row or a bounce off a 403.
 */
export const SETTINGS_TABS: ReadonlyArray<{
  id: SettingsTabId;
  label: string;
  href: string;
  authority: "admin" | "branding";
}> = [
  { id: "branding", label: "Branding", href: "/settings", authority: "branding" },
  { id: "providers", label: "Model providers", href: "/settings/providers", authority: "admin" },
  { id: "security", label: "Security", href: "/settings/security", authority: "admin" },
  {
    id: "agent-teams",
    label: "Specialist teams",
    href: "/settings/agent-teams",
    authority: "admin",
  },
  { id: "channels", label: "Channels", href: "/settings/channels", authority: "admin" },
  { id: "connectors", label: "Connectors", href: "/settings/connectors", authority: "admin" },
  { id: "api-keys", label: "API keys", href: "/settings/api-keys", authority: "admin" },
  { id: "archived", label: "Archived", href: "/settings/archived", authority: "admin" },
];
